import { render, staticRenderFns } from "./ShopsFilterShopCard.vue?vue&type=template&id=09d5aba8&scoped=true&"
import script from "./ShopsFilterShopCard.vue?vue&type=script&lang=js&"
export * from "./ShopsFilterShopCard.vue?vue&type=script&lang=js&"
import style0 from "./ShopsFilterShopCard.vue?vue&type=style&index=0&id=09d5aba8&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d5aba8",
  null
  
)

export default component.exports